import React from 'react'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import { IconButton, InputAdornment } from '@mui/material'

interface NextAdornmentProps {
  onClick: () => void
}

export const NextAdornment: React.FC<NextAdornmentProps> = ({ onClick }) => {
  return (
    <InputAdornment position='end'>
      <IconButton onClick={onClick}>
        <NavigateNextIcon />
      </IconButton>
    </InputAdornment>
  )
}
